import { Indicator } from '../../../Common/Charts/Indicator';
import { useMortalityMobidityChartsDataContext } from './hooks/useMortalityMobidityChartsDataContext';

export const EarlyNeonatalMortality = () => {
    const { chartData } = useMortalityMobidityChartsDataContext();

    return (
        <Indicator
            title={'Mortalidade Neonatal Precoce - de 0 a 6 dias de vida'}
            indicatorValue={chartData?.indicators?.earlyNeonatalMortality}
            className="aligned-container"
            goalValue={1}
            goalMessage="Meta Aceitável - 10 a cada 1000"
        />
    );
};
